import { platformApi } from '@/apis';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function useNichePersonImage(id) {
  const queryKey = ['nichePersonImage', id];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: async ({ signal }) => {
      try {
        return await platformApi
          .get(`niche/people/${id}/image`, { signal })
          .text();
      } catch (error) {
        if (error.data?.statusCode === 404) {
          return null;
        } else {
          throw error;
        }
      }
    },
    enabled: !!id,
    staleTime: 1000 * 60 * 60,
  });

  return { query, cancel: () => queryClient.cancelQueries({ queryKey }) };
}
